const company = {
  company: {
    pageHeader: 'Bedrijfsprofiel',
    branchProfile: 'Afdelingsprofiel',
    addBranchOffice: 'Filiaal toevoegen',
    companyDetails: 'Bedrijfsgegevens',
    branchDetails: 'Taakomschrijving',
    companyName: 'Bedrijfsnaam',
    branchName: 'Naam van het filiaal',
    websiteURL: 'Website URL',
    url: 'URL',
    yearFounded: 'Jaar Opgericht',
    companyLogo: 'Bedrijfslogo',
    imageFormatDescription: 'Moet een JPEG-, GIF- of PNG-bestand zijn dat niet groter is dan 4 MB.',
    imageShapeDescription:
      'Voor het beste resultaat raden wij aan een vierkante afbeelding te gebruiken met een transparante achtergrond van minimaal 400px breed bij 400px hoog.',
    noFile: 'Geen bestand geselecteerd',
    companyDescription: 'Beschrijving van het bedrijf',
    myTestEdit: 'Mijn testebewerking',
    customerWelcomeEmail: 'Welkomstbericht voor de klant',
    testEditMessage: 'testbewerkingsvoor het mailbericht',
    companyDescriptionTooltip:
      "Tekst die hier wordt ingevoerd zal verschijnen op de publieke pagina van de systemen die door uw bedrijf zijn geïnstalleerd. Het is mogelijk dat u contactgegevens wenst op te nemen om sales leads te genereren van bezoekers van deze pagina's.",
    editCompanyInformation: 'Bewerk bedrijfsinformatie',
    welcomeEmailDescription:
      'Tekst die hier wordt ingevoerd zal verschijnen in de welkomstmail die naar nieuwe klanten wordt gestuurd wanneer een Enlighten-account wordt aangemaakt. U kunt ervoor kiezen om uw bedrijfslogo bij dit bericht te voegen.',
    editWelcomeMessage: 'Bewerk het welkomstbericht voor de klant',
    checkboxDisplayLogo: 'Vertoning bedrijfslogo in welkomstbericht voor de klant',
    previewEmail: 'Voorbeeld van een welkomstmail van de klant',
    contactDetails: 'Contactgegevens',
    streetAddress: 'Adres',
    streetAddress2: 'Straatadres 2',
    city: 'Stad',
    zipCode: 'Postcode',
    customerSupport: 'Contacten voor klantenondersteuning',
    country: 'Land',
    state: 'Staat/provincie',
    contactOwnerDescription: 'voor systeemeigenaar / huiseigenaar om contact mee op te nemen ',
    businessContacts: 'Zakelijke contacten',
    sameCheckbox: 'Hetzelfde als de klantenondersteuning',
    contactEnphaseDescription: 'voor Enphase om contact mee op te nemen',
    installationDetails: 'Installatie details',
    servicesOffered: 'Aangeboden diensten',
    installationType: 'Type installatie',
    salesEmployeeNumber: 'Aantal medewerkers in de verkoop',
    workmanshipWarranty: 'Aangeboden garantie op vakmanschap (Jaar)',
    installationEmployeeNumber: 'Aantal medewerkers die installaties uitvoeren',
    typicalInstallationsYear: 'Typische installaties (per jaar)',
    typicalInstallationsMonth: 'Typische installaties (kW / maand)',
    enphaseShare: 'Aandeel Enphase in installaties',
    sgipDeveloper: 'Bent u een SGIP-ontwikkelaar?',
    sgipDeveloperTooltip: 'Selecteer of u geregistreerd bent als SGIP-ontwikkelaar op selfgenca.com.',
    fein_ein: 'FEIN/EIN',
    sgipDeveloperKey: 'SGIP Developer Key',
    businessLicenses: 'Zakelijke licenties',
    addNewLicense: 'NIEUWE LICENTIE TOEVOEGEN',
    licenseType: 'Type vergunning',
    licenseNo: 'Licentienummer',
    none: 'Geen',
    licensingBoard: 'Vergunningscommissie',
    licensingAuthority: 'Vergunningverlenende instantie',
    expiryDate: 'Vervaldatum',
    profileLinks: 'Profiel links',
    yelpAccountLink: 'Yelp Account Link',
    rating: 'Beoordeling: ',
    reviews: 'Reviews: ',
    yelpAccountLinkTooltip:
      'Om deze link te krijgen, gaat u naar uw Yelp-profiel en kopieert u de link/URL in de adresbalk van uw internetbrowser.',
    yelpAccountLinkError:
      'We waren niet in staat om uw yelp-profiel te ontvangen. Controleer de door u ingevoerde profiellink opnieuw.',
    googlePlaceId: 'Google Plaats-ID',
    clickHere: 'Klik hier',
    findPlaceId: 'om je google place ID te vinden',
    placeIdError:
      'We hebben geen geldige locatie voor dit ID kunnen vinden. Controleer a.u.b. opnieuw de door u ingevoerde ID.',
    solarProfileLink: 'SolarReviews Profiel Link',
    solarProfileLinkTooltip:
      'Ga voor deze link naar uw SolarReviews.com-profiel en kopieer de link/URL in de adresbalk van uw internetbrowser.',
    bbbProfileLink: 'BBB Profiel Link',
    bbbProfileLinkTooltip:
      'Om deze link te krijgen, gaat u naar uw BBB.org profiel en kopieert u de link/URL in de adresbalk van uw internetbrowser.',
    solarQuotesProfileLink: 'Solarquotes Profiel Link',
    solarQuotesTooltip:
      'Om deze link te krijgen, gaat u naar uw solarquotes.com.au-profiel en kopieert u de link/URL in de adresbalk van uw internetbrowser.',
    productReviewProfileLink: 'ProductReview Profiel Link',
    productReviewTooltip:
      'Om deze link te krijgen, gaat u naar uw productreview.com.au profiel en kopieert u de link/URL in de adresbalk van uw internetbrowser.',
    trustPilotLink: 'Trustpilot Profiel Link',
    trustPilotTooltip:
      'Om deze link te krijgen, gaat u naar uw trustpilot.com profiel en kopieert u de link/URL in de adresbalk van uw internetbrowser',

    facebookLink: 'Facebook Profiel Link',
    facebookTooltip:
      'Om deze link te krijgen, gaat u naar uw facebook.com profiel en kopieert u de link/URL in de adresbalk van uw internetbrowser',

    justDialLink: 'Just Dial Profiel Link',
    justDialTooltip:
      'Om deze link te krijgen, gaat u naar uw justdial.com profiel en kopieert u de link/URL in de adresbalk van uw internetbrowser',
    listOfReferenceSystems: 'Lijst van referentiesystemen',
    referenceListDescription:
      'Uw referentielijst wordt automatisch bijgewerkt om systemen te laten zien die eigenaren hebben gekozen om te delen. Systemen op de lijst hebben minstens 100kWh levenslange energie.',
    requestSystemAccess: 'Systeemtoegang aanvragen',
    maintainer: 'Onderhoudsmonteur',
    view_only: 'Alleen bekijken',
    linkRequestAccess: 'Stuur deze link naar systeemeigenaren om toegang te vragen tot hun systeem in Enlighten.',
    fieldRequired: 'Dit veld is verplicht.',
    validEmail: 'Voer een geldig e-mailadres in.',
    validPhone: 'Voer een geldig telefoonnummer in.',
    supportContact: 'Vul a.u.b. ten minste één van de bovenstaande velden in (Telefoon/E-mail).',
    serviceRequired: 'Ten minste één servicetype is vereist',
    installationRequired: 'Er is ten minste één installatietype nodig',
    minLength: 'Minimaal toegestane lengte is 2',
    maxLength: 'Maximaal toegestane lengte is 15',
    dateWarning:
      'Waarschuwing: Deze licentie zal worden beschouwd als vervallen, aangezien de vervaldatum in het verleden ligt.',
    correctValue: 'Voer een waarde in die kleiner is dan of gelijk is aan\xa0',
    feinLength: 'Voer een 9-cijferig getal in',
    less_than_25: 'Minder dan 25%',
    between_25_50: '25 tot 50%',
    between_50_90: '50% tot 90%',
    greater_than_90: 'Meer dan 90%',
    roofing: 'Dakbedekking',
    solar: 'Zonne-energie',
    storage: 'Opslag',
    electrical: 'Elektrisch',
    ev_charger: 'EV-lader',
    others: 'Andere',
    commercial: 'Commercieel',
    residential: 'Residentieel',
    new_homes: 'Nieuwbouw',
    installer: 'Installateur',
    roles_distributor: 'Distributeur',
    roles_support: 'Ondersteunend bedrijf',
    cec: 'CEC',
    electrical_contract: 'Elektrisch contract',
    abn_number: 'ABN Nummer',
    acn_number: 'ACN-nummer',
    sgze: 'SGZE',
    zonnekeur: 'Zonnekeur',
    holland_solar: 'Holland Solar',
    techniek_nederland: 'Techniek Nederland',
    installq: 'InstallQ',
    fedelec: 'Fedelec',
    pv_vlaanderen: 'PV Vlaanderen',
    installateurverzeichniss_elektro_eintrag: 'Installateurverzeichniss Elektro Eintrag',
    selectCountry: 'Gelieve een land te selecteren',
    yellowPageLink: 'Link gouden gids',
    yellowPageTooltip: `Om deze link te krijgen, ga naar uw profiel https://www.pagesjaunes.fr/ en kopieer de link/URL in de adresbalk van uw internetbrowser.`,
    enrQualityDirectoryLink: 'Annuary Qualit’Enr',
    enrQualityDirectoryTooltip: `Om deze link te krijgen, ga naar uw profiel https://www.qualit-enr.org/annuaire/ en kopieer de link/URL in de adresbalk van uw internetbrowser.`,
    validChamberNumber: 'Ongeldige invoer! Minimaal 8 tekens vereist voor KvK-nummer',
    chamberofcommerce : 'Kamer van koophandelnummer',
  }
};

export default company;
